import { Button } from "../../../../shadcn/components/ui/button";
import CustomModalLayoutV2 from "../../../bidder/Tabs/auctionFloor/components/CustomModalLayoutV2";
import PDFViewer from "../../../banker/bidder/PDFViewer";
import { ButtonStatusText } from "../../../../shadcn/components/custom/ButtonStatusText";
import { cn } from "../../../../shadcn/lib/utils";

interface PDDocumentPreviewModalPropTypes {
  openPreviewModal: boolean;
  documentTitle: string;
  documentPreviewUrl: string;
  documentDownloadUrl: string;
  handleClosePreviewModal: () => void;
  onDownloadDocumentCtaClick?: () => void;
  onWhatsAppButtonClick?: () => void;
  downloadDocumentButtonStates: {
    processing: boolean;
    error: boolean;
    success: boolean;
  };
  showWhatsAppButton?: boolean;
  whatsAppButtonStates?: {
    processing: boolean;
    error: boolean;
    success: boolean;
  };
}

export const PDDocumentPreviewModal: React.FC<
  PDDocumentPreviewModalPropTypes
> = ({
  openPreviewModal = false,
  documentTitle = "Untitled Document",
  documentPreviewUrl = "",
  documentDownloadUrl = "",
  showWhatsAppButton,
  handleClosePreviewModal = () => {},
  onDownloadDocumentCtaClick = () => {},
  onWhatsAppButtonClick = () => {},
  downloadDocumentButtonStates = {
    processing: false,
    error: false,
    success: false,
  },
  whatsAppButtonStates = { processing: false, error: false, success: false },
}) => {
  const handleDownloadFileToSystem = () => {
    if (documentDownloadUrl) {
      window.open(documentDownloadUrl, "_blank");
    }
  };

  return (
    <CustomModalLayoutV2
      open={openPreviewModal}
      blurBackground={true}
      onClose={handleClosePreviewModal}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4 w-full md:w-[400px] overflow-y-scroll max-h-[calc(100%-10px)]"
    >
      <h2 className="py-4 font-semibold text-gray-900 text-lg">
        {documentTitle}
      </h2>

      {documentPreviewUrl ? (
        <PDFViewer
          pdf_url={documentPreviewUrl}
          containerStyle={{ maxHeight: "400px" }}
        />
      ) : (
        <div className="h-[400px] flex items-center justify-center border">{`No file preview available`}</div>
      )}

      <div
        className={cn(
          "grid sm:grid-cols-2 gap-2",
          showWhatsAppButton ? "" : "sm:grid-cols-1",
        )}
      >
        <Button
          className="w-full mt-4 bg-brand-primaryAction hover:bg-brand-primaryAction"
          onClick={() => {
            handleDownloadFileToSystem();
            onDownloadDocumentCtaClick?.();
          }}
          disabled={
            downloadDocumentButtonStates?.processing ||
            downloadDocumentButtonStates?.success ||
            !documentDownloadUrl
          }
        >
          <ButtonStatusText
            title="Download Document"
            successTitle="Downloaded"
            failureTitle="Failed to Download"
            processingTitle="Downloading"
            buttonStates={downloadDocumentButtonStates}
          />
        </Button>

        {showWhatsAppButton && (
          <Button
            className="w-full mt-4 bg-brand-primaryAction hover:bg-brand-primaryAction"
            onClick={onWhatsAppButtonClick}
            disabled={
              whatsAppButtonStates?.processing ||
              whatsAppButtonStates?.success ||
              !documentPreviewUrl
            }
          >
            <ButtonStatusText
              title="Send to WhatsApp"
              successTitle="Sent to WhatsApp"
              failureTitle="Failed to Send"
              processingTitle="Sending to WhatsApp"
              buttonStates={whatsAppButtonStates}
            />
          </Button>
        )}
      </div>
    </CustomModalLayoutV2>
  );
};
